import { KeyboardEventHandler, SyntheticEvent, useEffect, useRef, useState } from 'react';

interface TextFieldProps {
  className?: string;
  isReadonly?: boolean;
  label?: string;
  labelPosition?: 'left' | 'top';
  placeholder?: string;
  value?: string;
  tabIndex?: number;
  onChange?: (newValue: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: (evt: KeyboardEvent) => void;
  autoFocus?: boolean;
}
const TextField: React.FC<TextFieldProps> = ({
  className,
  isReadonly = false,
  label,
  labelPosition = 'left',
  placeholder,
  value,
  tabIndex,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  autoFocus = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [actualValue, setActualValue] = useState<string>(value ?? '');
  // const [textInputId] = useState(_uniqueId('textInput-'));

  useEffect(() => {
    value !== undefined && setActualValue(value);
    autoFocus && inputRef.current?.focus();
    return () => {};
  }, [value]);

  const handleChange = (evt: SyntheticEvent<HTMLInputElement>) => {
    setActualValue(evt.currentTarget.value);
    onChange && onChange(evt.currentTarget.value);
  };

  const handleKeyDown = (evt: SyntheticEvent<HTMLInputElement>) => {
    const keyBoardEvent = evt.nativeEvent as KeyboardEvent;
    onKeyDown && onKeyDown(keyBoardEvent);
    if (keyBoardEvent.code === 'Enter') {
      inputRef.current?.blur();
    }
  };

  return (
    <div
      className={`flex ${className ?? ''} ${labelPosition === 'top' ? 'flex-col' : 'items-center'}`}
      tabIndex={tabIndex}
    >
      {label && (
        <label
          className={`text-md font-bold ${labelPosition === 'top' ? 'pb-2' : 'pr-2'}`}
          htmlFor="todo"
        >
          {label}
        </label>
      )}
      <input
        ref={inputRef}
        className={`w-full truncate border-none px-3 py-2 pr-10 focus:border-none focus:outline-none  ${
          isReadonly ? '!border-none bg-transparent' : 'bg-inputDefaultBgColor'
        }`}
        type="text"
        id="todo"
        readOnly={isReadonly}
        value={actualValue}
        onChange={handleChange}
        placeholder={placeholder}
        onKeyDownCapture={handleKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};

export default TextField;
